<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" v-has="'PlatAdmin'" @click="doAdd()">添加</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip v-has="'PlatAdmin'" effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                        <el-tooltip v-has="'PlatAdmin'" effect="dark" content="锁定" placement="top">
                            <el-button size="small" icon="el-icon-lock" v-has="'PlatAdmin'" @click="doLock()"></el-button>
                        </el-tooltip>
                        <el-tooltip v-has="'PlatAdmin'" effect="dark" content="解除锁定" placement="top">
                            <el-button size="small" icon="el-icon-unlock" v-has="'PlatAdmin'" @click="doUnlock()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="人员名称" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.key" clearable placeholder="登录账号" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column type="expand" label="...">
                    <template slot-scope="props">
                        <el-card style="margin: 10px;" v-for="item in props.row.binds" :key="item.pid">
                            <div slot="header">
                                <span>[{{ item.pbno }}] {{ item.pname }}</span>
                                <el-button style="float: right; padding: 3px 0" type="text" @click="doUnbindPlan(props.row, item)">解除绑定</el-button>
                            </div>
                            <el-tag :key="venues.vid" v-for="venues in item.venues" style="margin: 5px;" closable :disable-transitions="true" @close="doUnbindVenues(props.row, venues)">
                                {{ venues.vroom }}
                            </el-tag>
                        </el-card>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="人员名称" width="250">
                    <template slot-scope="scope">
                        <el-tag type="danger" size="mini" style="margin-right: 10px;" v-if="scope.row.lock.flg">已锁定</el-tag>
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="人员账号" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.key }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="人工审核" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.maudit ? '支持' : '不支持' }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="面试审核" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.aiv ? '支持' : '不支持' }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="监考统计">
                    <template slot-scope="scope">已绑定{{ scope.row.binds.length }}个计划</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="最后登录" width="250">
                    <template slot-scope="scope">
                        <p>地址：{{ scope.row.last.ip }}</p>
                        <p>时间：{{ scope.row.last.time }}</p>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" v-has="'PlatAdmin'" @click.stop="doEdit(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="详情" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="formDialog" width="500px">
            <el-form ref="form" :model="field" :rules="rules" label-width="80px">
                <el-form-item label="人员名称" prop="name">
                    <el-input v-model="field.name" placeholder="请填写监考人名称"></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="key">
                    <el-input v-model="field.key" placeholder="请填写登录账号，手机号"></el-input>
                </el-form-item>
                <el-form-item label="人工审核" prop="maudit">
                    <el-switch v-model="field.maudit" active-color="#13ce66" inactive-color="#ff4949" active-text="开启" inactive-text="关闭"></el-switch>
                </el-form-item>
                <el-form-item label="面试审核" prop="aiv">
                    <el-switch v-model="field.aiv" active-color="#13ce66" inactive-color="#ff4949" active-text="开启" inactive-text="关闭"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    保存
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    name: '',
    key: ''
}
const defaultField = {
    id: '',
    name: '',
    key: '',
    maudit: false,
    aiv: false
}
export default {
    name: 'RecProctor',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            field: {
                ...defaultField
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请填写监考人名称',
                        trigger: 'blur'
                    }
                ],
                key: [
                    {
                        required: true,
                        message: '请填写登录账号，手机号',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            submitLoading: false
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['招聘管理', '监考人员'])
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
        },
        doLoad() {
            this.tableLoading = true
            this.$http
                .get('/ops/recruit/proctor/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },
        clearFields() {
            this.field = {
                ...defaultField
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
                this.$refs['form'].clearValidate()
            }
        },
        doAdd() {
            this.clearFields()
            this.formDialog = true
        },
        doEdit(item) {
            this.clearFields()
            this.field = {
                ...item
            }
            this.formDialog = true
        },
        doSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    this.$http.post('/ops/recruit/proctor/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/proctor/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        },
        doLock(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要锁定登录的账户')
                return
            }
            this.$prompt('', '请输入锁定原因', {
                confirmButtonText: '锁定',
                cancelButtonText: '取消',
                inputValue: '账户违规，锁定登录',
                type: 'warning'
            })
                .then(({ value }) => {
                    this.$http
                        .post('/comm/user/lock', {
                            ids: ids.join(),
                            memo: value,
                            hour: 24 * 30 * 6
                        })
                        .then(result => {
                            if (result.code === 0) {
                                this.$message.success('锁定成功')
                                this.doLoad()
                            }
                        })
                })
                .catch(() => {})
        },
        doUnlock(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要解除锁定的账户')
                return
            }
            this.$confirm('是否解除账户[' + names.join() + ']的锁定状态?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/comm/user/unlock', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('解除锁定成功')
                            this.doLoad()
                        }
                    })
            })
        },
        doUnbindPlan(user, plan) {
            this.$confirm('是否解除监考人[' + user.name + ']和计划[' + plan.pname + ']的绑定关系?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/proctor/unbind', {
                        uid: user.id,
                        pid: plan.pid,
                        vid: ''
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('解除绑定成功')
                            this.doLoad()
                        }
                    })
            })
        },
        doUnbindVenues(user, venues) {
            this.$confirm('是否解除监考人[' + user.name + ']和考场[' + venues.vroom + ']的绑定关系?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/proctor/unbind', {
                        uid: user.id,
                        pid: '',
                        vid: venues.vid
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('解除绑定成功')
                            this.doLoad()
                        }
                    })
            })
        }
    }
}
</script>
